import { render } from "./Modal.vue?vue&type=template&id=0a90a2c4"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=0a90a2c4&lang=scss"

import exportComponent from "D:\\Server\\Projects\\aurus-applications-support\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__